import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useNotifications from '../hooks/useNotifications';
import TokenService from '../services/tokenService';

const NotificationInitializer = () => {
  const { initialize } = useNotifications();
  
  // Get authentication state from Redux
  const loginUser = useSelector((state) => state.loginUser);
  const isAuthenticated = loginUser?.success && TokenService.getToken();

  useEffect(() => {
    // Initialize notifications only when user is authenticated
    if (isAuthenticated) {
      console.log('User authenticated, initializing push notifications...');
      initialize();
    }
  }, [isAuthenticated, initialize]);

  // This component doesn't render anything
  return null;
};

export default NotificationInitializer;